import { PageCollectionConfigLanguage } from '@creator-suite/page-types';
import {
  getZodNumberWithCountryCodeSchema,
  ZIP_REGEX,
  ZOD_CITY_MAX_LENGTH,
} from '@creator-suite/page-types/zod';
import { z } from 'zod';

export interface InsertLeadToPageResponse {
  redirect?: string;
}

export const FIRST_NAME_MAX_LENGTH = 50;
export const LAST_NAME_MAX_LENGTH = 50;
export const STREET_MAX_LENGTH = 100;
export const HOUSE_NUMBER_MAX_LENGTH = 20;

export const getInsertLeadToPageSchemaByLanguage = (
  language: PageCollectionConfigLanguage,
) =>
  z.object({
    phone: getZodNumberWithCountryCodeSchema(language),
    zip: z
      .string()
      .regex(ZIP_REGEX, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? 'Ungültige Postleitzahl.'
            : 'Invalid ZIP code.',
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    email: z
      .string()
      .email({
        message:
          language === PageCollectionConfigLanguage.DE
            ? 'Ungültige E-Mail-Adresse.'
            : 'Invalid email address.',
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    city: z
      .string()
      .max(ZOD_CITY_MAX_LENGTH, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? `Stadt darf maximal ${ZOD_CITY_MAX_LENGTH} Zeichen haben.`
            : `City can have a maximum of ${ZOD_CITY_MAX_LENGTH} characters.`,
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    street: z
      .string()
      .max(STREET_MAX_LENGTH, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? `Straße darf maximal ${STREET_MAX_LENGTH} Zeichen haben.`
            : `Street can have a maximum of ${STREET_MAX_LENGTH} characters.`,
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    houseNumber: z
      .string()
      .max(HOUSE_NUMBER_MAX_LENGTH, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? `Hausnummer darf maximal ${HOUSE_NUMBER_MAX_LENGTH} Zeichen haben.`
            : `House number can have a maximum of ${HOUSE_NUMBER_MAX_LENGTH} characters.`,
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    firstName: z
      .string()
      .max(FIRST_NAME_MAX_LENGTH, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? `Vorname darf maximal ${FIRST_NAME_MAX_LENGTH} Zeichen haben.`
            : `First name can have a maximum of ${FIRST_NAME_MAX_LENGTH} characters.`,
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    lastName: z
      .string()
      .max(LAST_NAME_MAX_LENGTH, {
        message:
          language === PageCollectionConfigLanguage.DE
            ? `Nachname darf maximal ${LAST_NAME_MAX_LENGTH} Zeichen haben.`
            : `Last name can have a maximum of ${LAST_NAME_MAX_LENGTH} characters.`,
      })
      .optional()
      .or(z.literal(''))
      .transform((value) => (!value ? undefined : value)),
    consent: z.boolean().optional(),
  });

export type InsertLeadToPageFormSchemaType = z.infer<
  ReturnType<typeof getInsertLeadToPageSchemaByLanguage>
>;
